import React, { Component } from 'react';
import { Navigate } from "react-router-dom";

import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Grid';
import {  styled } from '@mui/material/styles';

//import UserService from "./UserService";
import AuthService from "./services/LoginService";
import DashBoardService from './services/DashBoardService';
import EventBus from "./common/EventBus";

const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: 'center',
    color: theme.palette.text.primary,
    height: 140,
}));



class Home extends Component {
    constructor(props) {
        super(props);

        this.state = {
            redirect: null,
            metrics : {},
        };

        this.retrieveDashboard = this.retrieveDashboard.bind(this);

    }

    componentDidMount() {

        const currentUser = AuthService.getCurrentUser();
        if (!currentUser) {
            this.setState({ redirect: "/login" });
        } else {
            this.retrieveDashboard();
        }
    }


    retrieveDashboard() {
        DashBoardService.get()
            .then((response) => {
                const metrics = response.data;
               // console.log(metrics);
                this.setState({
                    metrics: metrics,
                });
            })
            .catch((error) => {
                console.log(error);
                if (error.response && error.response.status === 401) {
                    EventBus.dispatch("logout");
                }
            });

    }




    render() {
        if (this.state.redirect) {
            return <Navigate to={this.state.redirect} />
        }
        const { metrics } = this.state;
        return (
            <div>



                <Box sx={{
                    flexGrow: 1,
                    height: 300,
                    backgroundColor: '#798997',
                }} container spacing={2}>

                    <Container fluid >
                        <br />
                        <Row>
                            <Col xs={10} md={10}><h3><b>Tableau de bord</b></h3></Col>

                        </Row>
                        <br />
                    </Container>
                    <Grid container justifyContent="center" spacing={2}>
                        <Grid item xs={2} >
                            <Item>
                                <span style={{ fontWeight: 'bold', color: 'blue', fontSize: "35px" }}>10/10</span>
                                <br />
                                Note moyenne des avis des stagiaires
                            </Item>
                        </Grid>
                        <Grid item xs={2}>
                            <Item>
                                <span style={{ fontWeight: 'bold', color: 'red', fontSize: "35px" }}>{metrics["En Attente"]}</span>
                                <br />
                                Dossiers non traités
                            </Item>
                        </Grid>
                        <Grid item xs={2}>
                            <Item>
                                <span style={{ fontWeight: 'bold', color: 'orange', fontSize: "35px" }}>{metrics["En Cours"]}</span>
                                <br />
                                Dossiers en cours
                            </Item>
                        </Grid>
                        <Grid item xs={2}>
                            <Item>
                                <span style={{ fontWeight: 'bold', color: 'red', fontSize: "35px" }}>{metrics["Validé"]}</span>
                                <br />
                                Dossiers à facturer
                            </Item>
                        </Grid>
                        <Grid item xs={2}>
                            <Item>
                                <span style={{ fontWeight: 'bold', color: 'green', fontSize: "35px" }}>{metrics["Terminé"]}</span>
                                <br />
                                Dossiers cloturés
                            </Item>
                        </Grid>
                    </Grid>
                </Box>

            </div>






        );
    }
}
export default Home;